import * as yup from 'yup'

export const name = () =>
  yup
    .string()
    // eslint-disable-next-line no-template-curly-in-string
    .max(15, '${path} length must be less then 15')
    // eslint-disable-next-line no-template-curly-in-string
    .matches(/^[a-zA-Zа-яА-Я ,.’-]+$/i, '${path} must be valid')
